export default __webpack_public_path__ + "static/media/emeka.876587cf.png";